import styled, { css } from 'styled-components'
import media from 'css-in-js-media'
import { Variables } from '../styles/Variables'

export const TabsWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`

export const Tabs = styled.div`
    display: flex;
    align-items: stretch;
    border: 1px solid ${Variables.color.cocoa};
    border-radius: 2px;
    ${media('>=desktop')} {
        justify-content: center;
    }
    ${media('<desktop')} {
        width: 100%;
    }
`

export const Tab = styled.div`
    font-weight: normal;
    font-size: 24px;
    line-height: 30px;
    text-align: center;
    letter-spacing: 0.0125em;
    padding: 15px 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    box-sizing: border-box;    
    font-family: ${Variables.font.title};
    border-bottom-style: solid;
    border-bottom-color: ${Variables.color.white};
    border-bottom-width: 1px;

    ${media('<desktop')} {
        flex-grow: 1;
        font-size: 16px;
        line-height: 20px;
        padding: 5px 20px;
    }

    ${media('>=desktop')} {
        min-width: 160px;
    }

    ${({ active }) =>
        active &&
        css`            
            border-bottom-width: 5px;
        `}
`

export const TabsContent = styled.div`

`

export const TabContent = styled.div`
    display: none;
    ${({ active }) =>
        active &&
        css`
            display: block;
        `}
`
